import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  RESET_PASSWORD__FEATURE_KEY,
  ResetPasswordState,
} from './reset-password.reducer';

/**
 * Retrieves the ContactPointState from the feature state.
 *
 * @returns The ContactPointState from the feature state.
 */
export const getResetPasswordState = createFeatureSelector<ResetPasswordState>(
  RESET_PASSWORD__FEATURE_KEY,
);

export const selectResetPasswordSended = createSelector(
  getResetPasswordState,
  (state: ResetPasswordState) => state.sended || false,
);
export const selectResetPasswordProcessing = createSelector(
  getResetPasswordState,
  (state: ResetPasswordState): boolean => state.processing || false,
);
export const selectResetPasswordResendingCode = createSelector(
  getResetPasswordState,
  (state: ResetPasswordState): boolean => state.resending || false,
);
export const selectResetPasswordError = createSelector(
  getResetPasswordState,
  (state: ResetPasswordState) => state.formErrors,
);
export const selectResetPasswordArguments = createSelector(
  getResetPasswordState,
  (
    state: ResetPasswordState,
  ): { password?: string; username?: string; attributeKey?: string } => {
    return {
      password: state.password,
      username: state.username,
      attributeKey: state.attributeKey,
    };
  },
);
